module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header text-center\">\n        <h4 class=\"modal-title\">{{ header }}</h4>\n    </div>\n    <div class=\"modal-body\">\n        {{ message }}\n    </div>\n    <div class=\"modal-footer\">\n        <button class=\"btn btn-primary\" (click)=\"closeModal()\">OK</button>\n      </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/modals/components/modalMessageOk/modalMessageOk.html
// module id = ../../../../../src/app/theme/components/modals/components/modalMessageOk/modalMessageOk.html
// module chunks = 14